import React from "react";
import Typography from "@mui/material/Typography";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";

export default function AcrPrimaryMetric({ sim }: MetricComponentProps) {
  const c = useCurrencyFormatter();

  const formattedBudget = React.createElement(
    React.Fragment,
    null,
    c(sim.maxAffordable, true),
    " ",
    React.createElement(
      Typography,
      {
        variant: "body1",
        color: "text.secondary",
        sx: { display: "inline" },
      } as any,
      "/month",
    ),
  );

  return <MetricItem value={formattedBudget} tooltip="Monthly Budget" />;
}
